/**
 * @deprecated This modal is no longer used automatically.
 * Users with placeholder email will see a banner on the Account page instead.
 * Use AddEmailModal for manual email addition.
 */
export function EmailPromptModal() {
  // Disabled: We no longer block users without email
  // They can add email optionally from Account page
  return null
}
